import React from "react";
import { TextField, Button, Box, Typography, Link, CircularProgress } from "@mui/material";
import { useTranslation } from "@/hooks/useTranslation";

const VerificationStep = ({
    email,
    code,
    onChange,
    onSubmit,
    onResendCode,
    onTryAnotherEmail,
    isLoading,
    onKeyPress
}) => {
    const { t } = useTranslation();
    
    return (
        <>
            <Typography variant="body2" sx={{ mb: 2 }}>
                {t('auth.login.codeSent', { email })}
            </Typography>
            
            <TextField
                fullWidth
                label={t('auth.login.verificationCode')}
                variant="outlined"
                value={code}
                onChange={(e) => onChange(e.target.value)}
                onKeyPress={(e) => onKeyPress(e, onSubmit)}
                margin="normal"
                disabled={isLoading}
            />
            
            <Button
                fullWidth
                variant="contained"
                onClick={onSubmit}
                disabled={code.length < 5 || isLoading}
                sx={{ mt: 2 }}
            >
                {isLoading ? (
                    <CircularProgress size={24} color="inherit" />
                ) : (
                    t('auth.login.signIn')
                )}
            </Button>
            
            <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
                <Link 
                    component="button"
                    variant="body2"
                    onClick={onTryAnotherEmail}
                    disabled={isLoading}
                >
                    {t('auth.login.tryAnotherEmail')}
                </Link>
                
                <Link 
                    component="button"
                    variant="body2"
                    onClick={onResendCode}
                    disabled={isLoading}
                >
                    {t('auth.login.resendCode')}
                </Link>
            </Box>
        </>
    );
};

export default VerificationStep;